import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { VertiLoginFailure, VertiLoginRequest, VertiLoginSuccess } from './actions';
import { LoginResponse } from '@models/swagger';

export const featureKey = 'vertiLogin';

export interface State {
  data: LoginResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(VertiLoginFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(VertiLoginRequest, state => ({ ...state, error: null, loading: true })),
    on(VertiLoginSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
